"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MetadataDeleteErrorModal_module_css_1 = __importDefault(require("./MetadataDeleteErrorModal.module.css"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var react_i18next_1 = require("react-i18next");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var material_1 = require("@mui/material");
var MetadataDeleteErrorModal = function (props) {
    var onClose = props.onClose, message = props.message, data = props.data, rest = __rest(props, ["onClose", "message", "data"]);
    var _a = (0, react_i18next_1.useTranslation)("translation"), t = _a.t, i18n = _a.i18n;
    var APP_URL = process.env.APP_URL;
    var logger = q_play_core_1.logManager.getLogger();
    var lng = i18n.language;
    var groupedData = data.reduce(function (acc, slide) {
        var presentation_id = slide.presentation_id, presentation_title = slide.presentation_title, type = slide.type;
        var presentationKey = presentation_id.toString();
        if (!acc[presentationKey]) {
            acc[presentationKey] = {
                presentation_id: presentation_id,
                presentation_title: presentation_title,
                type: type,
                slides: [],
            };
        }
        acc[presentationKey].slides.push(slide);
        return acc;
    }, {});
    return (react_1.default.createElement(q_play_components_1.Modal, __assign({ onClose: onClose }, rest, { dialogClassName: "".concat(MetadataDeleteErrorModal_module_css_1.default["remove-resource-error-dialog"]), centered: true, body: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", { className: MetadataDeleteErrorModal_module_css_1.default["modal-body-message"] }, t(message, { defaultValue: message })),
            (data === null || data === void 0 ? void 0 : data.length) > 0 && (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "d-flex flex-column gap-2" }, Object.values(groupedData).map(function (presentation, index) {
                    var formattedType = presentation.type === "PLAYLIST" ? t("Playlist") : t("Presentation");
                    return (react_1.default.createElement("div", { key: index },
                        react_1.default.createElement("div", { className: "d-flex align-items-center ".concat(MetadataDeleteErrorModal_module_css_1.default["presentation-header"]) },
                            react_1.default.createElement("span", { className: MetadataDeleteErrorModal_module_css_1.default["resource-name"], onClick: function () {
                                    if (APP_URL &&
                                        presentation.presentation_id &&
                                        presentation.type) {
                                        var url = "".concat(APP_URL, "/editor/").concat(presentation.type.toLowerCase(), "/").concat(presentation.presentation_id, "?lng=").concat(lng);
                                        window.open(url, "_blank");
                                    }
                                    else {
                                        logger.error("APP_URL, presentation_id, or type is not defined.");
                                    }
                                } },
                                formattedType,
                                ": ",
                                presentation.presentation_title)),
                        react_1.default.createElement("div", { className: "d-flex" },
                            react_1.default.createElement("div", { className: "d-flex flex-column", style: { flex: 1 } }, presentation.slides.slice(0, 3).map(function (slide, idx) { return (react_1.default.createElement("div", { key: idx, className: MetadataDeleteErrorModal_module_css_1.default["slide-item"] },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAngleRight, className: MetadataDeleteErrorModal_module_css_1.default["primary-icon"] }),
                                react_1.default.createElement("span", { style: { marginLeft: "1em" } }, slide.slide_title))); })),
                            react_1.default.createElement("div", { className: "d-flex flex-column", style: { flex: 1 } },
                                presentation.slides.slice(3, 5).map(function (slide, idx) { return (react_1.default.createElement("div", { key: idx, className: MetadataDeleteErrorModal_module_css_1.default["slide-item"] },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAngleRight, className: MetadataDeleteErrorModal_module_css_1.default["primary-icon"] }),
                                    react_1.default.createElement("span", { style: { marginLeft: "1em" } }, slide.slide_title))); }),
                                presentation.slides.length > 6 && (react_1.default.createElement(material_1.Tooltip, { title: react_1.default.createElement("div", null, presentation.slides.slice(6).map(function (slide) { return (react_1.default.createElement("div", { key: slide.slide_id }, slide.slide_title)); })), placement: "right", PopperProps: {
                                        sx: {
                                            ".MuiTooltip-arrow": {
                                                color: "var(--secondary-color)",
                                            },
                                            ".MuiTooltip-tooltip": {
                                                backgroundColor: "var(--secondary-color)",
                                                color: "var(--info-color)",
                                                borderRadius: "7px",
                                                padding: "10px",
                                                position: "relative",
                                                left: "-150px",
                                            },
                                        },
                                    } },
                                    react_1.default.createElement("div", { className: MetadataDeleteErrorModal_module_css_1.default["more-slides"] },
                                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAngleRight, className: MetadataDeleteErrorModal_module_css_1.default["primary-icon"] }),
                                        react_1.default.createElement("span", { style: { marginLeft: "1em" } },
                                            presentation.slides.length - 6,
                                            " ",
                                            t("more...")))))))));
                })))),
            react_1.default.createElement("div", { className: MetadataDeleteErrorModal_module_css_1.default["cancel-button-container"] },
                react_1.default.createElement(q_play_components_1.Button, { text: t("Cancel"), onClick: onClose }))) })));
};
exports.default = MetadataDeleteErrorModal;
